<template>
  <div class="header ">
    <div class="header left">
      <!-- <img class="logo" src="@/assets/logo.png" alt="" />
      <header-menu></header-menu> -->
      <div style="display: flex;width: 100%;height: 73px;justify-content: center;background-color: #fff;">
        <div :index="i.path" v-for="i of menuList" :key="i.path" :class="selectpath == i.path ? 'selectchange' : 'noselect'" @click="selectFun(i.path)">
          {{i.label}}
        </div>
        <div><img class="logo" src="@/assets/news/logo1.png" alt="" /></div>
        <div
          :index="i.path"
          v-for="i of menuList1"
          :key="i.path"
          :class="selectpath == i.path ? 'selectchange' : 'noselect'"
          @click="selectFun(i.path)"
          :style="i.path == '/contactUs' ? 'margin-right: 65px;' : ''">
          {{i.label}}
        </div>
      </div>
      <!-- <el-menu
        :default-active="activeIndex"
        class="el-menu-header layou-box"
        mode="horizontal"
        style="display: flex;justify-content: center;    right: 32px;margin:0 auto;"
        @select="handleSelect"
      >
        <el-menu-item :index="i.path" v-for="i of menuList" :key="i.path">{{
          i.label
        }}</el-menu-item>
        <div><img class="logo" src="@/assets/news/logo1.png" alt="" /></div>
        <el-menu-item :index="i.path" v-for="i of menuList1" :key="i.path">{{
          i.label
        }}</el-menu-item>
      </el-menu> -->
      <div style="top: 66px;height: 200px;width: 100%;background:url('../../assets/news/logo2.png')">
        <img src="@/assets/news/logo2.png" alt="" style="width: 100%;height:100%"/>
      </div>
    </div>
    <!-- <div class="right">
      <el-button
        v-if="!user.isLogin"
        type="primary"
        @click="showLogin = true"
        size="mini"
        >登录</el-button
      >
      <span v-else>
        <el-dropdown @command="handlerCommand">
          <span class="el-dropdown-link" style="cursor: pointer">
            XXX<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div> -->
    <!-- 登录窗口 -->
    <login-vue :visible.sync="showLogin"></login-vue>
  </div>
</template>

<script>
import LoginVue from "@/components/Login/Login.vue";
// import HeaderMenu from "./HeaderMenu.vue";
import { mapState } from "vuex";
export default {
  name: "HeaderVue",
  components: {
    // HeaderMenu,
    LoginVue,
  },
  data() {
    return {
      showLogin: false,
      menuList: [
        {
          label: "首页",
          path: "/home",
        },
        {
          label: "新闻公告",
          path: "/competitionGuide",
        },
        {
          label: "组织机构",
          path: "/organizationalStructure",
        },
        {
          label: "学术活动",
          path: "/academicActivities",
        },
        {
          label: "研究成果",
          path: "/researchFindings",
        },
      ],
      menuList1: [
        {
          label: "科普活动",
          path: "/sciencePopularizationActivities",
        },
        {
          label: "学会成员",
          path: "/societyMembers",
        },
        {
          label: "关于我们",
          path: "/aboutUs",
        },
        {
          label: "联系我们",
          path: "/contactUs",
        }
      ],
      selectpath: '/competitionGuide' 
    };
  },
  computed: {
    activeIndex() {
      return this.$route?.meta?.activePath || this.$route.path;
    },
    ...mapState({
      user: (state) => state.user,
    }),
  },
  created() {
    console.log('ddddd', this)
    this.selectpath = this.$route.path
    this.$bus.$on("login", () => {
      this.showLogin = true;
    });
  },
  methods: {
    selectFun(val) {
      this.selectpath = val
      this.$router.push(val)
    },
    handleSelect(key) {
      if(this.activeIndex != key) {
        this.$router.push({ path: key });
      }
    },
    handlerCommand(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
      }
    },
    logout() {},
  },
};
</script>

<style lang="less" scoped >
.el-menu-header {
  border-bottom: 0 !important;
  /deep/ .el-menu-item {
    color: #000000;
    border-bottom: 0;
    border-top: 2px solid transparent;
    &.is-active {
      background-color: #f6f7fc;
      color: #436eff !important;
      font-weight: bold;
      border-top: 2px solid #436eff;
      border-bottom: 0;
    }
    &:not(.is-disabled):hover,
    &:not(.is-disabled):focus {
      background-color: #f6f7fc;
    }
  }
}
.header {
  height: 100%;
  // display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    width: 90px;
    height: 90px;
    object-fit: contain;
    position: sticky;
    z-index: 99999999;
    // margin-right: 30px;
  }
}
.selectchange {
  background-color: #f6f7fc;
  color: #436eff !important;
  font-weight: bold;
  border-top: 2px solid #436eff;
  border-bottom: 0;
  height: 60px;
  line-height: 60px;
  padding: 0 20px;
  cursor: pointer;
}
.noselect {
  color: #000000;
  border-bottom: 0;
  border-top: 2px solid transparent;
  height: 60px;
  padding: 0 20px;
  line-height: 60px;
  cursor: pointer;
}
</style>